export const transitions = {
  PREPARE_FOR_PAYMENT: 'transition/prepare-for-payment',
  EXPIRE_WITHOUT_PAYMENT: 'transition/expire-without-payment',
  REQUEST_PAYMENT: 'transition/request-payment',
  CONFIRM_PAYMENT: 'transition/confirm-payment',
  EXPIRE_PAYMENT: 'transition/expire-payment',
  FAIL_PAYMENT: 'transition/fail-payment',
  CANCEL: 'transition/cancel',
  AUTO_COMPLETE: 'transition/auto-complete',
};

export const states = {
  INITIAL: 'initial',
  READY_FOR_PAYMENT: 'ready-for-payment',
  PENDING_PAYMENT: 'pending-payment',
  PURCHASED: 'purchased',
  PAYMENT_EXPIRED: 'payment-expired',
  PAYMENT_FAILED: 'payment-failed',
  CANCELED: 'canceled',
  COMPLETED: 'completed',
};

export const graph = {
  id: 'delivery-purchase/release-1',
  initial: states.INITIAL,
  states: {
    [states.INITIAL]: {
      on: {
        [transitions.PREPARE_FOR_PAYMENT]: states.READY_FOR_PAYMENT,
      },
    },
    [states.READY_FOR_PAYMENT]: {
      on: {
        [transitions.REQUEST_PAYMENT]: states.PENDING_PAYMENT,
        [transitions.EXPIRE_WITHOUT_PAYMENT]: states.PAYMENT_EXPIRED,
      },
    },
    [states.PENDING_PAYMENT]: {
      on: {
        [transitions.CONFIRM_PAYMENT]: states.PURCHASED,
        [transitions.EXPIRE_PAYMENT]: states.PAYMENT_EXPIRED,
        [transitions.FAIL_PAYMENT]: states.PAYMENT_FAILED,
      },
    },
    [states.PURCHASED]: {
      on: {
        [transitions.CANCEL]: states.CANCELED,
        [transitions.AUTO_COMPLETE]: states.COMPLETED,
      },
    },
    [states.CANCELED]: { type: 'final' },
    [states.COMPLETED]: { type: 'final' },
  },
};

export const isPrivileged = transition => {
  return [transitions.PREPARE_FOR_PAYMENT, transitions.REQUEST_PAYMENT].includes(transition);
};

export const isCompleted = transition => {
  const txCompletedTransitions = [transitions.AUTO_COMPLETE];
  return txCompletedTransitions.includes(transition);
};

export const isRefunded = transition => {
  const txRefundedTransitions = [transitions.EXPIRE_PAYMENT, transitions.CANCEL];
  return txRefundedTransitions.includes(transition);
};

export const isRelevantPastTransition = transition => {
  return [
    transitions.PREPARE_FOR_PAYMENT,
    transitions.EXPIRE_WITHOUT_PAYMENT,
    transitions.REQUEST_PAYMENT,
    transitions.CONFIRM_PAYMENT,
    transitions.EXPIRE_PAYMENT,
    transitions.FAIL_PAYMENT,
    transitions.CANCEL,
    transitions.AUTO_COMPLETE,
  ].includes(transition);
};

export const isCustomerReview = transition => {
  return false;
};

export const isProviderReview = transition => {
  return false;
};

export const statesNeedingProviderAttention = [];

export const listingTypes = ['delivery'];
